import Axios from 'axios';
import qs from 'qs';
import { openNewWindow, isDomainRu, stringifyPaginationV3 } from '@/_helpers/utils.js';

const testEnvironments = ['localhost:8080', 'test01.vcv.team', 'test02.vcv.team', 'test03.vcv.team', 'test04.vcv.team'];

let integrationHost = process.env.INTEGRATION_HOST;

if (testEnvironments.includes(window.location.host)) {
  integrationHost = process.env.INTEGRATION_HOST_TEST;
}

if (!isDomainRu) {
  integrationHost = process.env.INTEGRATION_HOST_AI;
}

const getDefaultState = () => ({
  headhunterApiAccess: null,
  vacanciesHeadhunter: [],
  vacanciesHeadhunterPagination: {
    _page: 1,
    _page_count: 0,
    _total_items: 0,
    _limit: 20
  },
  vacanciesHeadhunterFilters: {
    filterTitleSelected: '',
    filterRegionSelected: '',
    filterAuthorSelected: []
  },
  headhunterManagers: [],
  headhunterManagersKeyword: '',
  headhunterManagersPagination: {
    _page: 1,
    _page_count: 0,
    _total_items: 0,
    _limit: 20
  },
  vacanciesHeadhunterLoading: false,
  isHeadhunterLoading: false,
  isHeadhunterAccessGranted: false,
  // Периодический запрос
  integrationInterval: null,
  integrationIntervalCount: 0,
  // Лимиты по конкретному пользователю в Headhunter
  headhunterLimits: null,
  headhunterUser: null
});

const state = getDefaultState();

const getters = {
  getHeadhunterManagerById: state => managerId => {
    const manager = state.headhunterManagers.find(x => x.id === managerId);

    if (manager !== undefined) {
      return { fullName: manager.full_name, email: manager.email };
    } else {
      return { fullName: '', email: '' };
    }
  },

  getHeadhunterManagers: state => {
    return state.headhunterManagers.map(x => ({ id: x.id, name: x.full_name }));
  },

  getHeadhunterUserInfo: state => {
    let info = '';

    if (state.headhunterUser !== null) {
      if (state.headhunterUser.first_name !== undefined) {
        info += ` ${state.headhunterUser.first_name}`;
      }
      if (state.headhunterUser.last_name !== undefined) {
        info += ` ${state.headhunterUser.last_name}`;
      }
      if (state.headhunterUser.email !== undefined) {
        info += ` (${state.headhunterUser.email})`;
      }
    }

    return info;
  },

  getHeadhunterLimits: state => {
    let info = '';

    if (state.headhunterLimits !== null) {
      info += `Просмотрено резюме пользователем: ${state.headhunterLimits.spend.resume_view} из ${state.headhunterLimits.limits.resume_view}. Ограничение для компании: ${state.headhunterLimits.left.resume_view}`;
    }

    return info;
  }
};

const mutations = {
  SET_API_ACCESS: (state, payload) => {
    state.headhunterApiAccess = payload;
  },

  SET_VACANCIES_HEADHUNTER: (state, payload) => {
    state.vacanciesHeadhunter = payload;
  },

  SET_VACANCIES_HEADHUNTER_LOADING: (state, payload) => {
    state.vacanciesHeadhunterLoading = payload;
  },

  SET_HEADHUNTER_MANAGERS: (state, payload) => {
    state.headhunterManagers = payload;
  },

  ADD_HEADHUNTER_MANAGERS: (state, payload) => {
    state.headhunterManagers = state.headhunterManagers.concat(payload);
  },

  SET_HEADHUNTER_MANAGERS_KEYWORD: (state, payload) => {
    state.headhunterManagersKeyword = payload;
  },

  SET_HEADHUNTER_MANAGERS_PAGINATION: (state, payload) => {
    state.headhunterManagersPagination = payload;
  },

  SET_HEADHUNTER_MANAGERS_PAGINATION_PAGE: (state, page) => {
    state.headhunterManagersPagination._page = page;
  },

  // Очищаем или добавляем объект _embedded в вакансии, так как именно на наличие его проверяется есть ли связь с vcv
  TOGGLE_VACANCY_EMBEDDED: (state, payload) => {
    const vacancyIndex = state.vacanciesHeadhunter.findIndex(x => x.id == payload.vacancyId);

    if (vacancyIndex > -1) {
      if (payload.isActive) {
        state.vacanciesHeadhunter[vacancyIndex]._embedded = { vacancy: payload.vacancy };
      } else {
        state.vacanciesHeadhunter[vacancyIndex]._embedded.vacancy = undefined;
      }
    }
  },

  SET_IS_HEADHUNTER_LOADING: (state, payload) => {
    state.isHeadhunterLoading = payload;
  },

  SET_IS_HEADHUNTER_ACCESS_GRANTED: (state, payload) => {
    state.isHeadhunterAccessGranted = payload;
  },

  STOP_INTERVAL_INTEGRATION_CHECK: state => {
    clearInterval(state.integrationInterval);
    state.integrationIntervalCount = 0;
  },

  INCREMENT_INTEGRATION_INTERVAL_COUNT: state => {
    state.integrationIntervalCount += 1;
  },

  SET_INTEGRATION_INTERVAL: (state, payload) => {
    state.integrationInterval = payload;
  },

  SET_HEADHUNTER_LIMITS: (state, payload) => {
    state.headhunterLimits = payload;
  },

  SET_HEADHUNTER_USER: (state, payload) => {
    state.headhunterUser = payload;
  },

  // SORT_VACANCIES: (state, sortSettings) => {
  //   state.vacanciesHeadhunter.sort((a, b) => {
  //     // Здесь небольшое усложнение, чтобы можно было сортировать данные по подключенным вакансиям
  //     // Если в _embedded есть непустой объект значит подключение есть и нужно поднимать вверх по сортировке
  //     if (sortSettings.name === 'isVacancyAssigned') {
  //       if (
  //         a._embedded.vacancy !== undefined &&
  //         Object.keys(a._embedded.vacancy).length !== 0 &&
  //         b._embedded.vacancy === undefined
  //       ) {
  //         return 1;
  //       }
  //       return -1;
  //     } else {
  //       if (sortSettings.order === 'desc') {
  //         if (a[sortSettings.name] > b[sortSettings.name]) return 1;
  //         if (a[sortSettings.name] < b[sortSettings.name]) return -1;
  //       } else {
  //         if (a[sortSettings.name] < b[sortSettings.name]) return 1;
  //         if (a[sortSettings.name] > b[sortSettings.name]) return -1;
  //       }
  //       return 0;
  //     }
  //   });
  // },

  SET_PAGINATION_PARAMS_PAGE: (state, page) => {
    state.vacanciesHeadhunterPagination._page = page;
  },

  SET_PAGINATION_PARAMS_TOTALITEMS: (state, totalItems) => {
    state.vacanciesHeadhunterPagination._total_items = totalItems;
  },

  SET_PAGINATION_PARAMS_PAGECOUNT: (state, pageCount) => {
    state.vacanciesHeadhunterPagination._page_count = pageCount;
  },

  SET_PAGINATION_PARAMS_LIMIT: (state, limit) => {
    state.vacanciesHeadhunterPagination._limit = limit;
  },

  SET_FILTER_TITLE: (state, searchString) => {
    state.vacanciesHeadhunterFilters.filterTitleSelected = searchString;
  },

  SET_FILTER_REGION: (state, searchString) => {
    state.vacanciesHeadhunterFilters.filterRegionSelected = searchString;
  },

  SET_FILTER_AUTHORS: (state, arrayAuthors) => {
    state.vacanciesHeadhunterFilters.filterAuthorSelected = arrayAuthors;
  },

  RESET_INTEGRATIONS_HEADHUNTER: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchApiAccess({ commit, rootGetters }) {
    commit('SET_IS_HEADHUNTER_LOADING', true);
    const params = rootGetters['integrations/getIntegrationParams']('headhunter');

    if (params.access_token) {
      await Axios.get(`${integrationHost}/v1/headhunter/api-access`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(response => {
          commit('SET_API_ACCESS', response.data);
        })
        .finally(() => {
          commit('SET_IS_HEADHUNTER_LOADING', false);
        });
    }
  },

  async fetchHeadhunterManagers({ commit, rootGetters }, loadMore = false) {
    const params = rootGetters['integrations/getIntegrationParams']('headhunter');
    const requestParams = {
      filter: {
        full_name: state.headhunterManagersKeyword
      }
    };

    let newPage = state.headhunterManagersPagination._page;

    if (loadMore) {
      if (newPage < state.headhunterManagersPagination._page_count) {
        newPage = state.headhunterManagersPagination._page + 1;
      }
    } else {
      newPage = 1;
    }

    if (params.access_token) {
      if (
        !loadMore ||
        (loadMore && state.headhunterManagersPagination._page_count > state.headhunterManagersPagination._page)
      ) {
        commit('SET_HEADHUNTER_MANAGERS_PAGINATION_PAGE', newPage);
        const paginationString = stringifyPaginationV3(state.headhunterManagersPagination);

        await Axios.get(`${integrationHost}/v1/headhunter/managers?${paginationString}`, {
          headers: { Authorization: `Bearer ${params.access_token}` },
          params: requestParams,
          paramsSerializer: requestParams => {
            return qs.stringify(requestParams);
          }
        }).then(response => {
          if (loadMore) {
            commit('ADD_HEADHUNTER_MANAGERS', response.data._embedded.managers);
          } else {
            commit('SET_HEADHUNTER_MANAGERS', response.data._embedded.managers);
          }

          commit('SET_HEADHUNTER_MANAGERS_PAGINATION', {
            _page: response.data._page,
            _page_count: response.data._page_count,
            _total_items: response.data._page_count,
            _limit: 20
          });
        });
      }
    } else {
      this._vm.$noty.error('Вы не авторизованы в headhunter. Это можно сделать в Настройках компании – Интеграции');
    }
  },

  async startHeadhunterSyncVacancies({ commit, rootGetters }) {
    commit('SET_VACANCIES_HEADHUNTER_LOADING', true);

    const params = rootGetters['integrations/getIntegrationParams']('headhunter');

    if (params.access_token) {
      await Axios.post(
        `${integrationHost}/v1/headhunter/sync-vacancies`,
        {},
        { headers: { Authorization: `Bearer ${params.access_token}` } }
      )
        .then(response => {
          if (response.status === 200) {
            this._vm.$noty.success('В течение нескольких минут данные по вакансиям обновятся');
          }
          if (response.status === 429) {
            this._vm.$noty.success(
              'Вы слишком часто отправляли запрос на ручное обновление. Можно обновлять не чаще 5 раз в час'
            );
          }
        })
        .finally(() => {
          commit('SET_VACANCIES_HEADHUNTER_LOADING', false);
        });
    } else {
      this._vm.$noty.error('Вы не авторизованы в headhunter. Это можно сделать в Настройках компании – Интеграции');
      commit('SET_VACANCIES_HEADHUNTER_LOADING', false);
    }
  },

  async fetchVacanciesFromHeadhunter({ commit, state, rootGetters, rootState }) {
    commit('SET_VACANCIES_HEADHUNTER_LOADING', true);

    const paginationString = stringifyPaginationV3(state.vacanciesHeadhunterPagination);
    const params = rootGetters['integrations/getIntegrationParams']('headhunter');
    const url = `${integrationHost}/v1/headhunter/raw-vacancies?with[]=vacancy&with[]=manager${paginationString}&sort[vacancy_id]=${rootState.vacancy_new.item.id}&sort[by]=vacancy&sort[order]=desc`;
    const requestParams = {
      filter: {
        manager_id: state.vacanciesHeadhunterFilters.filterAuthorSelected,
        title: state.vacanciesHeadhunterFilters.filterTitleSelected,
        region: state.vacanciesHeadhunterFilters.filterRegionSelected
      }
    };

    if (params.access_token) {
      await Axios.get(url, {
        headers: { Authorization: `Bearer ${params.access_token}` },
        params: requestParams,
        paramsSerializer: requestParams => {
          return qs.stringify(requestParams);
        }
      })
        .then(response => {
          if (response.status === 200) {
            commit('SET_VACANCIES_HEADHUNTER', response.data._embedded.raw_vacancies);

            if (response.data._page !== undefined) {
              commit('SET_PAGINATION_PARAMS_PAGE', response.data._page);
            }
            if (response.data._page_count !== undefined) {
              commit('SET_PAGINATION_PARAMS_PAGECOUNT', response.data._page_count);
            }
            if (response.data._total_items !== undefined) {
              commit('SET_PAGINATION_PARAMS_TOTALITEMS', response.data._total_items);
            }
          }
        })
        .finally(() => {
          commit('SET_VACANCIES_HEADHUNTER_LOADING', false);
        });
    } else {
      this._vm.$noty.error('Вы не авторизованы в headhunter. Это можно сделать в Настройках компании – Интеграции');
      commit('SET_VACANCIES_HEADHUNTER_LOADING', false);
    }
  },

  async connectVacancyToVcv({ commit, rootGetters }, payload) {
    const params = rootGetters['integrations/getIntegrationParams']('headhunter');

    if (params.access_token) {
      await Axios.post(`${integrationHost}/v1/headhunter/vacancies`, payload.params, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      }).then(response => {
        commit('TOGGLE_VACANCY_EMBEDDED', {
          vacancyId: payload.vacancyId,
          isActive: true,
          vacancy: response.data
        });
      });
    }
  },

  async removeVacancyFromVcv({ commit, rootGetters }, vacancy) {
    const params = rootGetters['integrations/getIntegrationParams']('headhunter');

    if (params.access_token) {
      await Axios.delete(`${integrationHost}/v1/headhunter/vacancies/${vacancy.integrationVacancyId}`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      }).then(() => {
        commit('TOGGLE_VACANCY_EMBEDDED', { vacancyId: vacancy.id, isActive: false });
      });
    }
  },

  // Периодические запросы к интеграционному сервису чтобы увидеть когда появится access_token в params
  startIntervalIntegrationCheckHeadhunter({ commit, dispatch, state }) {
    const integrationInterval = setInterval(() => {
      if (state.integrationIntervalCount <= 6) {
        commit('INCREMENT_INTEGRATION_INTERVAL_COUNT');
        dispatch('grantAccessToHeadHunter');
      } else {
        commit('STOP_INTERVAL_INTEGRATION_CHECK');
        commit('SET_IS_HEADHUNTER_LOADING');
      }
    }, 1000);

    commit('SET_INTEGRATION_INTERVAL', integrationInterval);
  },

  async grantAccessToHeadHunter({ commit, dispatch, rootGetters }, isUserChange = false) {
    commit('SET_IS_HEADHUNTER_LOADING', true);
    commit('SET_IS_HEADHUNTER_ACCESS_GRANTED', false);

    // Запрашиваем список интеграций (в новом списке должен появится access_token для каждой интеграции)
    await dispatch('integrations/fetchIntegrationsInstalls', null, { root: true });

    const params = rootGetters['integrations/getIntegrationParams']('headhunter');

    if (params.access_token) {
      commit('STOP_INTERVAL_INTEGRATION_CHECK');

      await Axios.get(`${integrationHost}/v1/headhunter/auth/status`, {
        headers: { Authorization: `Bearer ${params.access_token}` }
      })
        .then(async response => {
          // Записываем данные по текущему авторизованному в Headhunter пользователю и его лимиты на preview vacancies в Headhunter
          if (response.data.limits !== undefined) {
            commit('SET_HEADHUNTER_LIMITS', response.data.limits);
          }
          if (response.data.user !== undefined) {
            commit('SET_HEADHUNTER_USER', response.data.user);
          }

          // Если пользователя необходимо поменять isUserChange === true, то открываем окно перелогина
          if (!response.data.ok || (response.data.ok && isUserChange)) {
            commit('STOP_INTERVAL_INTEGRATION_CHECK');
            commit(
              'integrations/SET_INTEGRATIONS_INSTALLS_STATUS',
              { code: 'headhunter', value: response.data.ok },
              { root: true }
            );

            if (response.data.ok && isUserChange) {
              commit('SET_IS_HEADHUNTER_ACCESS_GRANTED', true);
            }

            await Axios.get(`${integrationHost}/v1/headhunter/auth/redirect-uri`, {
              headers: { Authorization: `Bearer ${params.access_token}` }
            })
              .then(response => {
                commit('SET_IS_HEADHUNTER_LOADING', false);

                const url = response.data.hh_redirect_uri;

                if (url) {
                  const windowParams = {
                    url: url,
                    title: 'Headhunter',
                    width: 700,
                    height: 550
                  };
                  openNewWindow(windowParams);
                } else {
                  this._vm.$noty.error(window.$tr('integrations.cant-grant-headhunter').text);
                }
              })
              .catch(() => {
                this._vm.$noty.error(window.$tr('common.error').text);
              });
          } else {
            commit('SET_IS_HEADHUNTER_LOADING', false);
            commit('SET_IS_HEADHUNTER_ACCESS_GRANTED', true);
          }
        })
        .catch(() => {
          this._vm.$noty.error(window.$tr('common.error').text);
        });
    } else {
      commit('SET_IS_HEADHUNTER_LOADING', false);
      this._vm.$noty.error(
        'Попробуйте установку интеграции еще раз. В случае повторного возникновения ошибки обратитесь в техническую поддержку.'
      );
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
